import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';

library.add(faPlus);

@Component({
  name: 'bpc-confirmation-modal',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class ConfirmationModal extends Vue {
  public entityIdOrIds;
  @Prop(Object) config: ConfirmationModalConfig;
  @Prop({ type: Boolean, default: false }) disableAcceptButton: boolean;
  @Prop({ type: Boolean, default: false }) disableCancelButton: boolean;
  @Prop({ type: Boolean, default: false }) hideHeaderCloseButton: boolean;
  @Prop({ type: Boolean, default: false }) noCloseOnBackdrop: boolean;
  @Prop({ type: Boolean, default: false }) noCloseOnEsc: boolean;
  @Prop({ type: Boolean, default: false }) showSpinner: boolean;
  @Prop({ type: String, default: 'md' }) size: string;

  onOpenModal(id) {
    this.entityIdOrIds = id;
    this.$bvModal.show(this.config.id);
  }
  onCloseModal() {
    this.$bvModal.hide(this.config.id);
    this.$emit('click-on-close');
  }
  onAcceptModal() {
    this.$emit('click-on-accept', { entityIdOrIds: this.entityIdOrIds });
  }
}
